import { render, staticRenderFns } from "./deactivate-site.vue?vue&type=template&id=99565b78&"
import script from "./deactivate-site.vue?vue&type=script&lang=js&"
export * from "./deactivate-site.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports